export { BookOpen as default } from './BookOpen';
